import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import {
  STATUS_CANCELLED,
  DISPLAY_STATUS,
  STATUS_STYLE_MAP,
  PROCESS_REQUEST_HAND_SHIPMENT_FIELD,
} from '../../../constants/ApprovalRequestConstants'
import { SSD_MATERIALS_STYLE_MAP } from '../../../constants/NonStockedSSDConstants'
import { Error, Loader, SSDMaterialsList } from '../../common'
import { selectSelectedApprovalRequest } from '../../../selectors/approvalRequests'
import { getSSDMetaData } from '../../../selectors/settings'
import {
  getNonStockedRequestHistory,
  getNonStockedRequestHistoryStatusProps,
} from '../../../selectors/requestHistory'
import { isExamPaper } from '../../../selectors/examWindows'
import { fetchNonStockedApprovalRequestHistory } from '../../../actions/approvalRequestHistory'

const mapStateToProps = (state, ownProps) => {
  const { panelIsOpen } = ownProps
  const selectedApprovalRequest = selectSelectedApprovalRequest(state)
  const { fetching, error } = getNonStockedRequestHistoryStatusProps(state)
  const { enrollmentId } = selectedApprovalRequest
  return {
    approvalHistory: getNonStockedRequestHistory(state, enrollmentId),
    enrollmentId,
    metaData: getSSDMetaData(state),
    fetching,
    error,
    panelIsOpen,
    isPaper: isExamPaper(
      state,
      selectedApprovalRequest.testCd,
      selectedApprovalRequest.examDateType
    ),
  }
}

const StatusExamDate = ({ etsApprovalStatus, examDate }) => {
  if (examDate) {
    return (
      <div style={SSD_MATERIALS_STYLE_MAP[etsApprovalStatus]}>
        Exam Date {formatDate(examDate, DATETIME_FORMATS.shortMonthDay)}
      </div>
    )
  }
  return null
}

const StatusComments = ({ comments }) => {
  if (comments) {
    return <div style={{ fontStyle: 'italic' }}>{`"${comments}"`}</div>
  }
  return null
}

const ApprovalRequestHistoryRow = connect(mapStateToProps)(({ status, key, first, isPaper }) => {
  const {
    etsApprovalStatus,
    reviewedBy,
    ssdDataSet,
    comments,
    examDateType,
    examDate,
    updateTimestamp,
  } = status
  return (
    <tr key={key}>
      <td style={first ? { borderTopWidth: 0 } : {}}>
        <div style={STATUS_STYLE_MAP[etsApprovalStatus]}>{DISPLAY_STATUS[etsApprovalStatus]}</div>
        {status[PROCESS_REQUEST_HAND_SHIPMENT_FIELD] && (
          <div style={{ fontStyle: 'italic' }}>Handshipped</div>
        )}
        {ssdDataSet.length && etsApprovalStatus !== STATUS_CANCELLED ? (
          <>
            <SSDMaterialsList selectedSSDMaterials={ssdDataSet} isPaper={isPaper}>
              <div style={SSD_MATERIALS_STYLE_MAP[etsApprovalStatus]} />
            </SSDMaterialsList>
            <StatusExamDate
              etsApprovalStatus={etsApprovalStatus}
              examDateType={examDateType}
              examDate={examDate}
            />
            {reviewedBy && <div>Processed By: {reviewedBy}</div>}
            <StatusComments comments={comments} />
          </>
        ) : null}
      </td>
      <td style={first ? { borderTopWidth: 0, whiteSpace: 'nowrap' } : { whiteSpace: 'nowrap' }}>
        {formatDate(updateTimestamp, DATETIME_FORMATS.longMonthDayYear)}
      </td>
    </tr>
  )
})

const ApprovalRequestHistoryTable = connect(mapStateToProps)(({ approvalHistory = [] }) => {
  return (
    <table
      className="table"
      summary="Status of Special Exam Materials approval requests are listed by status date in descending order."
    >
      <caption className="sr-only">
        A view of Special Exam Materials approval request history
      </caption>
      <thead>
        <tr>
          <th scope="col">Status</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {approvalHistory.map((row, index) => (
          <ApprovalRequestHistoryRow status={row} key={`${Math.random()}`} first={index === 0} />
        ))}
      </tbody>
    </table>
  )
})

class RequestHistory extends Component {
  componentDidMount() {
    const { enrollmentId, fetchNonStockedApprovalRequestHistory } = this.props

    fetchNonStockedApprovalRequestHistory(enrollmentId)
  }

  componentDidUpdate(prevProps) {
    const { enrollmentId, panelIsOpen, fetchNonStockedApprovalRequestHistory } = this.props

    if (panelIsOpen && prevProps.enrollmentId !== enrollmentId) {
      fetchNonStockedApprovalRequestHistory(enrollmentId)
    }
  }

  render() {
    const { approvalHistory = [], fetching, error } = this.props
    let output = null

    if (fetching) {
      output = <Loader />
    } else if (error) {
      output = <Error title="Error" message={error} />
    } else if (approvalHistory.length) {
      output = <ApprovalRequestHistoryTable />
    } else {
      output = <>No request history available</>
    }

    return (
      <div className="row">
        <div className="col-xs-12">{output}</div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { fetchNonStockedApprovalRequestHistory })(RequestHistory)
